import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 py-10 mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div className="text-sm text-zinc-500">
          © {new Date().getFullYear()} QR Readiness Audit · A one-shot audit tool.
        </div>
        <div className="flex items-center gap-6 text-sm">
          <Link to="/methodology" className="text-zinc-400 hover:text-white transition-colors duration-200">
            Methodology
          </Link>
          <Link to="/quiz" className="text-[#C6F84C] hover:text-[#B8FF3D] transition-colors duration-200">
            Start free audit →
          </Link>
        </div>
      </div>
    </footer>
  );
}
